export default "__VITE_ASSET__CDSeR$ME__"